import { useEffect, useState } from 'react'
// import Sidebar from '../Sidebar'
// import { useDispatch,useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import toast from 'react-hot-toast'
import UserHero from '../../userPages/partials/UserHero'
import ListGroup from '../../userPages/partials/ListGroup'
export default function AllBookingShow() {
  let [data , setData] = useState({})
    let [user , setUser] = useState({})
    // let [flag,setFlag] = useState(false)
    // let [wishlist ,setWishlist] = useState([])
    let [bookingStatus,setBookingStatus]=useState("")
    let [paymentStatus,setPaymentStatus]=useState("")
    let {_id} = useParams()
    
    // let dispatch = useDispatch()
    // let CheckoutStateData=useSelector((state)=>state.CheckoutStateData)






async function getApiData() {
    let response = await fetch( "http://34.228.14.188:8000/api/booking" , {
           method :"GET",
           headers:{
            "content-type":"application/json",
            // "authorization":localStorage.getItem("token")
                  }
    })

   let data = await response.json(); // Response JSON alag variable mein

        if (data.result === "Done") {
            // 🔥 Filter data: remove where paymentStatus = "pending" AND paymentMode = "Net Banking"
            const filteredData = data.data.filter(item => {
                 return !(item.paymentStatus?.toLowerCase().trim() === "pending" && item.paymentMode?.toLowerCase().trim() === "net banking");
                // return !(item.paymentStatus === "pending" && item.paymentMode === "Net Banking");
            });
            //  console.log(item.paymentStatus,item.paymentMode);
             
            console.log(filteredData); // just for checking
            let item = filteredData.find((x)=>x._id === _id)
            setData(item ); // ✅ Set only filtered data
             setBookingStatus(item?.bookingStatus)
        setPaymentStatus(item?.paymentStatus)
      setUser(item?.user);
        } else {
            setData([]);
        }
}

// function updateRecord() {
//            if(window.confirm("Did You Really Want to Change the Status :")){
              

//             let item = filteredData.find((x)=>x._id===_id)
            
//             dispatch(updateCheckout({...item , bookingStatus:bookingStatus , paymentStatus:paymentStatus}))
//              toast.success("Booking SuccessFully Update")
//             setFlag(!flag)
//             setData((old)=>{
//               return {
//               ...old,
//               bookingStatus : bookingStatus,
//               paymentStatus:paymentStatus

//               }
//             })
//            }
  
// }


async function updateRecord() {
  if (window.confirm("Did You Really Want to Change the Status?")) {
    try {
      const response = await fetch(`http://34.228.14.188:8000/api/booking/${_id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          // "Authorization": `Bearer ${localStorage.getItem("token")}`  // Optional if token-based
        },
        body: JSON.stringify({
          bookingStatus: bookingStatus,
          paymentStatus: paymentStatus
        })
      });

      const result = await response.json();

      if (result.success || result.result === "Done") {
        // toast.success("Booking Successfully Updated ✅");
        toast.success("Booking Successfully Updated ✅");
setTimeout(() => {
  window.location.href = "/admin/booking"; // Navigate back to list and reload
}, 1000);


        // Optional: refresh the state or update manually
        setData((old) => ({
          ...old,
          bookingStatus: bookingStatus,
          paymentStatus: paymentStatus
        }));

        // You can call getApiData() again to refresh full data
        // getApiData();
      } else {
        toast.error("Failed to update booking");
      }
    } catch (error) {
      console.error("Update error", error);
      toast.error("Error while updating booking");
    }
  }
}


//   function getAPIData() {

//     dispatch(getCheckout());
//    if(CheckoutStateData.length){
//    let item = CheckoutStateData.find((x)=> x._id === _id)
//         setData(item)
//         setOrderStatus(item.orderStatus)
//         setPaymentStatus(item.paymentStatus)
//       setUser(item.user);
//       console.log(CheckoutStateData);
      
//     }
//     else
//      setData([])

//   }


//   useEffect(()=>{
//     getAPIData();
//   },[CheckoutStateData.length])

useEffect(()=>{
    getApiData()
} ,[])

  return (
   <>
   <UserHero/>
   <div className="container-fluid"  style={{marginTop:100}}>
    <div className="row my-3">
         <ListGroup/>

        <div className="col-md-8 col-12 col-sm-12">
              <h5 className='testimonials-h1 text-light text-center p-2'>Booking Query Show</h5>
              
              <div className="table-responsive">
                <table className='table table-bordered'>
                  <tbody>
                    <tr>
                      <th>Id</th>
                      <td>{data?._id}</td>
                    </tr>
                    <tr>
                      <th>User</th>
                      <td>
                        {user?.name}<br/>
                        {user?.phone} ,  {user?.email}<br/>
                        {user?.address}<br/>
                        {user?.pin} , {user?.city} , {user?.state}<br/>
                      </td>
                    </tr>
                    <tr>
                      <th>Booking Status</th>
                      <td>
                      {data?.bookingStatus}
                      {
                      data?.bookingStatus !== "Complete" ?
                      <>
                      <br />
                      <select name="bookingStatus" value={bookingStatus} onChange={(e)=>setBookingStatus(e.target.value)} >
                        <option>Booking is Confirm</option>
                        <option>Booking is Complete</option>
                        {/* <option>In Transit</option>
                        <option>Order Reached to final Delivery Station</option>
                        <option>Out of Delivery</option>
                        <option>Delivered</option> */}
                      </select>
                      </>
                      :""
                      }
                      </td>
                    </tr>

                    <tr>
                      <th>Payment Mode</th>
                      <td>{data?.paymentMode}</td>
                    </tr>

                    <tr>
                      <th>Payment Status</th>
                      {/* <td>{data?.paymentStatus}
                         
                         {
                           data?.paymentStatus !== "Done" ?
                           <>
                           <br />
                           <select name="paymentStatus" value={paymentStatus} onChange={(e)=>setPaymentStatus(e)}>
                            <option>Pending</option> 
                            <option>Done</option>
                           </select>
                           </>

                           : ""
                         }


                      </td> */}

                      <td>
  {data?.paymentStatus}

  {data?.paymentStatus !== "Done" ? (
    <>
      <br />
      <select
        name="paymentStatus"
        value={paymentStatus}
        onChange={(e) => setPaymentStatus(e.target.value)}
      >
        <option value="Pending">Pending</option>
        <option value="Done">Done</option>
      </select>
    </>
  ) : (
    ""
  )}
</td>

                    </tr>

                   
                   

                    <tr>
                      <th>Total</th>
                      <td>&#8377;{data?.total} </td>
                    </tr>

                    <tr>
                      <th>RPPID</th>
                      <td>{data?.rppid} </td>
                    </tr>

                    <tr>
                      <th>Date</th>
                      <td>{ new Date( data?.date).toLocaleString()} </td>
                    </tr>


                    <tr>
                          <td  colSpan={2}>
                                      {
                                        data?.bookingStatus !== "Complete" || data.paymentStatus !== "Done" ? 
                                        <button  onClick={updateRecord}  className='testimonials-h1 text-light text-center p-2'>Update Status to Done</button>
                                        :""
                                      }
                                     
                          </td>
                    </tr>
                  </tbody>

                </table>
              </div>
              <h5 className='testimonials-h1 text-light text-center p-2'>Booking Details</h5>
              <div className="table-responsive">
                <table className='table table-bordered'>
                        <thead>
                          <tr>
                          <th>Room Pic</th>
                          <th>Room Name</th>
                          <th>Check In</th>
                          <th>Check out</th>
                          <th>Adult</th>
                          <th>Child</th>
                          <th>/Night</th>
                          <th>No. of Night</th>
                          <th>Room Quantity</th>
                          <th>Total</th>
                          </tr>
                        </thead>
                        <thead>
                     <tr>
                                <td>
                                        <img src={`/${data?.pic}`} alt="room pic" />
                                </td>
                                <td>{data?.name}</td>
                                <td>{data?.checkIn}</td>
                                <td>{data?.checkOut}</td>
                                <td>{data?.adult}</td>
                                <td>{data?.child}</td>
                                <td>&#8377;{data?.price}</td>
                                <td>{data?.days}</td>
                                <td>{data?.qty}</td>
                                <td>&#8377;{data?.total}</td>
                              </tr>
                           
                        </thead>
                </table>
              </div>
        </div>





       

        </div>
    </div>
   {/* </div> */}
   </>
  )
}